// Broad grooming patterns shared by the mesh and its vertex-color finish.
// They are evaluated only while constructing the catalog, never per frame.
export function longStrandFlow(angle, y) {
  // Broad locks curve from the part into a gently waving fall.
  const sweep = .18 + .16 * Math.sin((y + .2) * 3.5);
  return .5 + .5 * Math.cos(10 * (angle - sweep));
}

export function strandFlow(style,x,y,z) {
  let phase;
  if(style==='short')phase=x*22+z*7+.3;
  else if(style==='pompadour')phase=(x+.25*z*z+.18*z)*32+.5;
  else if(style==='long') {
    const fall=Math.max(0,Math.min(1,-y/.5));
    return longStrandFlow(Math.atan2(x,z+.26*fall),y);
  }
  else phase=Math.atan2(x,z)*6+2.4*y+.8;
  return .5+.5*Math.cos(phase);
}

const CURLS=Array.from({length:34},(_,i)=>{
  const y=1-i/33*1.48,r=Math.sqrt(1-y*y),a=i*2.39996323;
  return {x:Math.sin(a)*r,y,z:Math.cos(a)*r,
    height:.067+.033*(.5+.5*Math.sin(i*2.17)),spread:.019+.011*(.5+.5*Math.cos(i*1.73))};
});

export function curlRelief(x,y,z) {
  const length=Math.hypot(x,y,z)||1;x/=length;y/=length;z/=length;
  let relief=0;
  for(const curl of CURLS)relief=Math.max(relief,curl.height*Math.exp(-(1-x*curl.x-y*curl.y-z*curl.z)/curl.spread));
  return relief;
}
